/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/prizoteka2024'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Prizoteka2024 from '@routes/Prizoteka2024';

export const Route = createFileRoute('/prizoteka2024')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={Prizoteka2024} path='/prizoteka2024' />
  )
});
